//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CTitle',

  components: {},

  props: {
    value: {
      type: String,
      default: '',
    },

    dot: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {}
  },

  computed: {},

  methods: {},
}
